import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormikContextType } from 'formik';
import { useTranslation } from 'react-i18next';
import { handleAccordionCheckboxChange } from './StaffRoleForm';
import FormikNumberField from '../../../components/formikComponents/FormikNumberField';
import { STAFF_ROLES_CACHE_KEY } from '../../../constants';
import { StaffRoleErrors } from '../../../types';

const BasketDiscountForm = ({
  formik,
  objectId,
  currency,
  errors,
  clearError,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikContextType<any>;
  objectId: string;
  currency: string;
  errors: StaffRoleErrors;
  clearError: (errorKey: string) => void;
}) => {
  const { t } = useTranslation();
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  return (
    <Accordion
      expanded={accordionExpanded}
      onChange={(_event, isExpanded) => setAccordionExpanded(isExpanded)}
      sx={{
        boxShadow: 0,
        padding: 0,
        margin: 0,
        '&.MuiAccordion-root.Mui-expanded': {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="basketDiscount-panel"
        sx={{
          marginLeft: '-0.5rem',
          padding: 0,
          minHeight: '42px',
          '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: '42px',
          },
          '& .MuiAccordionSummary-content.MuiAccordionSummary-contentGutters, & .MuiAccordionSummary-expandIconWrapper':
            {
              margin: 0,
            },
        }}
        onClick={(event) => {
          event.stopPropagation();
          setAccordionExpanded(!accordionExpanded);
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, marginRight: '0.5rem' }}>
            <Checkbox
              id="discountOptsBasketDiscount"
              name="discountOptsBasketDiscount"
              checked={formik.values.discountOptsBasketDiscount}
              onChange={handleAccordionCheckboxChange(formik, objectId, [
                'discountOptsBasketDiscount',
              ])}
              onClick={(event) => event.stopPropagation()}
            />
            <Typography>{t('screens.staffRoles.allow_discountOptsBasketDiscount')}</Typography>
          </Box>
        </Box>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          paddingY: '0.5rem',
          paddingX: 0,
        }}
      >
        <Box
          sx={{
            border: '1px solid',
            borderColor: (currTheme) =>
              currTheme.palette.mode === 'light'
                ? currTheme?.palette?.grey?.['12p']
                : currTheme?.palette?.grey?.['23p'],
            borderRadius: '8px',
            padding: '0.5rem',
          }}
        >
          <Typography variant="body2" sx={{ marginBottom: '1rem' }}>
            {t('screens.staffRoles.defaultNoLimit')}
          </Typography>
          <FormikNumberField
            label={t('screens.staffRoles.discountOptsBasketDiscountLimit')}
            id="discountOptsBasketDiscountLimit"
            name="discountOptsBasketDiscountLimit"
            maxValue={9999999}
            minValue={0}
            decimalScale={2}
            prefix={currency}
            formName={STAFF_ROLES_CACHE_KEY}
            objectId={objectId}
            error={errors?.discountOptsBasketDiscountLimit}
            clearError={clearError}
          />
          <FormikNumberField
            label={t('screens.staffRoles.discountOptsBasketDiscountLimitPct')}
            id="discountOptsBasketDiscountLimitPct"
            name="discountOptsBasketDiscountLimitPct"
            suffix="%"
            sx={{ marginBottom: '0.5rem' }}
            decimalScale={2}
            maxValue={100}
            minValue={0}
            formName={STAFF_ROLES_CACHE_KEY}
            objectId={objectId}
            error={errors?.discountOptsBasketDiscountLimitPct}
            clearError={clearError}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default BasketDiscountForm;
